import { InventoryStockMovementType } from '@/renderer/types/inventory';

export const INVENTORY_STOCK_MOVEMENT_TYPE_OPTIONS: Array<{
  value: InventoryStockMovementType;
  label: string;
}> = [
  { value: 'purchase_receipt', label: 'Purchase Receipt' },
  { value: 'sale_consumption', label: 'Sale Consumption' },
  { value: 'transfer_out', label: 'Transfer Out' },
  { value: 'transfer_in', label: 'Transfer In' },
  { value: 'adjustment_increase', label: 'Adjustment Increase' },
  { value: 'adjustment_decrease', label: 'Adjustment Decrease' },
  { value: 'wastage', label: 'Wastage' },
  { value: 'return_to_supplier', label: 'Return to Supplier' },
  { value: 'stock_count_correction', label: 'Stock Count Correction' },
];

export const formatInventoryStockMovementType = (
  value: InventoryStockMovementType,
) =>
  INVENTORY_STOCK_MOVEMENT_TYPE_OPTIONS.find((option) => option.value === value)
    ?.label ?? value;
